import React, { useState, useMemo } from 'react';
import Layout from '../components/Layout'; // 引入 Layout 组件
import ColumnSettingsModal from '../components/ColumnSettingsModal';
import { allColumns } from '../config/columnsConfig'; // 引入共享的 allColumns 定义
import './SettingsPage.css';

function SettingsPage() {
    const [isColumnSettingsVisible, setIsColumnSettingsVisible] = useState(false);
    const [visibleColumns, setVisibleColumns] = useState(() => {
        const userSettings = JSON.parse(localStorage.getItem('userSettings')) || {};
        const tableSettings = userSettings?.tableSettings || {};
        return tableSettings?.visibleColumns || [            
            'Query',
            'Answer',
            '审核状态',
            '审核操作',
        ];
    });

    const handleEdit = () => {}; // 空的 handleEdit 函数

    const columns = useMemo(() => allColumns(handleEdit), [handleEdit]); // 调用 allColumns 函数

    const handleColumnSettingsSubmit = (selectedColumns) => {
        setVisibleColumns(selectedColumns);
        const userSettings = JSON.parse(localStorage.getItem('userSettings')) || {};
        const tableSettings = userSettings?.tableSettings || {};
        
        // 同步 filters 和 visibleColumns
        tableSettings.filters = (tableSettings.filters || []).filter((filter) =>
            selectedColumns.includes(filter.id)
        );
        
        tableSettings.visibleColumns = selectedColumns;
        localStorage.setItem('userSettings', JSON.stringify({ ...userSettings, tableSettings }));
        setIsColumnSettingsVisible(false);
    };

    return (
        <Layout>
            <div className="settings-page">
                <h1>Settings</h1>
                <button onClick={() => setIsColumnSettingsVisible(true)}>列显示设置</button>

                {isColumnSettingsVisible && (
                    <ColumnSettingsModal
                        allColumns={columns} // 传递生成的列配置
                        visibleColumns={visibleColumns}
                        onSubmit={handleColumnSettingsSubmit}
                        onCancel={() => setIsColumnSettingsVisible(false)}
                    />
                )}
            </div>
        </Layout>
    );
}

export default SettingsPage;